import {
  isSuperAdmin,
  isCommunityAdmin,
  isCommunityModerator,
} from 'src/helpers/roleUtils';

export const canCreateGroup = userRoles => {
  return (
    isSuperAdmin(userRoles) ||
    isCommunityAdmin(userRoles) ||
    isCommunityModerator(userRoles)
  );
};

export const canDeleteGroup = userRoles => {
  return isSuperAdmin(userRoles) || isCommunityAdmin(userRoles);
};

export const canNameChair = userRoles => {
  return (
    isSuperAdmin(userRoles) ||
    isCommunityAdmin(userRoles) ||
    isCommunityModerator(userRoles)
  );
};

export const canViewCGARoles = [
  'CGA_STUDENT',
  'CGA_STAFF',
  'SUPER_ADMIN',
  'COMMUNITY_ADMIN',
  'COMMUNITY_MODERATOR',
];
